import {Injectable} from "@angular/core";
import {VisbosService} from "../../../core/visbos-core/graphql/visbos.service";
import {Apollo} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store/store";
import {SessionActions} from "../../../shared/actions/session.actions";
import gql from "graphql-tag";
import {Warehousing} from "../../model/warehousing";
import {Observable} from "rxjs/Observable";
import {medicineBookFragments} from "../medicine.service";
import {map} from "rxjs/operators";

export const warehousingFragments = {
  warehousing: gql`
    fragment WarehousingFields on Warehousing {
      cuid, label, warehousing_timestamp,
      warehousing_reason_type,
      warehousing_note,
      warehousing_reason {
        cuid, label, __typename,
        ...on Delivery {
          delivery_date, packing_slip_number, recipient_name
        }
      }
      supplier {
        cuid, label, __typename,
        ... on AdministrationUnit {
          name
        }
        ... on Vehicle {
          license_plate
        }
      }
      total_amount,
      increased_stocks {
        cuid, label,
        stock {cuid, label, act_stock},
        amount,
        medicine_book_entry {
          ...MedicineBookEntryFields
        }
      }
    }
    ${medicineBookFragments.medicineBookEntry}
  `
};

export const createWarehousingMutation = gql`
  mutation CreateWarehousingMutation($warehousingInput: WarehousingInput!, $medicineAuthData: MedicineStockChangeInput) {
    createWarehousing(warehousing_input: $warehousingInput, medicine_auth_data: $medicineAuthData) {
      ...WarehousingFields
    }
  }

  ${warehousingFragments.warehousing}
`;

export interface CreateWarehousingResult {
  createWarehousing: Warehousing
}

@Injectable()
export class WarehousingService extends VisbosService {

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public createWarehousing(warehousingInput, medicineAuthData?): Observable<CreateWarehousingResult> {

    return this.mutate<CreateWarehousingResult>({
      mutation: createWarehousingMutation,
      variables: {
        warehousingInput: warehousingInput,
        medicineAuthData: medicineAuthData
      },
      refetchQueries: [],
    }).pipe(map(res => res.data));

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/warehousing-service/warehousing.service.ts